export const RECEIVED_CONFIG = "received_config";